import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  //a login component is responsible for creating the login page.
  constructor(public authService: AuthenticationService) { }

  signedIn = false;

  ngOnInit() {
    this.signedIn = false;
    this.authService.SignOut();
  }
}
